import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/shared/services/common.service';
import { DeviceService } from '../../device.service';
import { DatePipe } from '@angular/common';

@Component({
	selector: 'app-im-total-energy-usage',
	templateUrl: './im-total-energy-usage.component.html',
	styleUrls: []
})
export class ImTotalEnergyUsageComponent {

	@Input() device: any = {};

	maxDate = new Date((new Date()).getTime() - 24 * 60 * 60 * 1000); // yesterday
	toDate = this.maxDate; // yesterday
	fromDate = new Date((new Date()).getTime() - 30 * 24 * 60 * 60 * 1000); // 30 days ago
	minDate = this.fromDate;

	getDailyDetails: Subscription = new Subscription();

	energyUsageIsNotEmpty: boolean = true;

	energyUsageExport: any = [];
	chartsData = [];
	chartObject = {
		config: {
			hAxis: {
				title: this.translate.instant('g.date'),
				format: 'yyyy-MM-dd',
				slantedText: false,
			},
			colors: ['#327339'],
			legend: {
				position: 'top',
				alignment: 'center',
				textStyle: { fontSize: 12 }
			},
			titleTextStyle: {
				fontSize: 16,
				bold: true,
				color: '#333',
				paddingBottom: 20,
				paddingTop: 20
			},
		},
		columnNames: ['Time', 'Value'],
		hasData: false
	}

	constructor(
		private deviceService: DeviceService,
		private commonService: CommonService,
		private translate: TranslateService,
		private datePipe: DatePipe,
	) {}

	ngOnInit() {
		if (this.device?.config_info?.installation_date)
			this.minDate = moment.utc(this.device.config_info.installation_date * 1000).startOf('day').toDate();
	}

	ngOnChanges(changes) {
		if(changes.device && this.device)
			this.getEnergyUsage();
	}

	changeDate(field, value) {
		this[field] = value;
		this.getEnergyUsage();
	}
	
	getEnergyUsage() {
		const zoneDiff	= new Date().getTimezoneOffset() * -1;
		let fromDate:any	= new Date(new Date(this.fromDate).getTime() + (zoneDiff * 60 * 1000));
		let toDate:any = new Date(new Date(this.toDate).getTime() + (zoneDiff * 60 * 1000));
		fromDate = moment(fromDate).utc().startOf('day').unix();
		toDate = moment(toDate).utc().endOf('day').unix();

		const min = 0, max = 24;
		this.energyUsageExport = [];
		this.chartsData = [];
		this.energyUsageIsNotEmpty = false;

		const options = { checkConnectivityAfterShippingDate: true };
		this.getDailyDetails = this.deviceService.getDailyDetails(this.device.mac_address, fromDate, toDate, options).subscribe((data: any) => {
			for (const dayUnix in data) {
				const dayData = data[dayUnix] || {};

				if (!dayData.energy_usage)
					continue;

				for (let i = min; i < max; i++) {
					const mappedKey = this.getTimeByIndex(dayData.date, i);
					const value = Math.round(dayData.energy_usage[i] * 100) / 100;
					const time = this.datePipe.transform(mappedKey, 'MM/dd/yyyy hh:mm:ss a');

					if (value)
						this.energyUsageIsNotEmpty = true;

					this.chartsData.push([time, value]);

					if (dayData.energy_usage[i])
						this.energyUsageExport.push([time, value]);
				}
			}
		});
	}

	exportEnergyUsage() {
		const columnNames = [
			this.translate.instant('g.time'),
			this.translate.instant('g.value')
		];
		const fileName = this.translate.instant('iotemeter.performance_analytics.energy_usage');
		this.commonService.exportToCsv(columnNames, this.energyUsageExport, fileName);
	}

	getTimeByIndex(dayTime: number, idx: number) {
		const zoneDiff = new Date().getTimezoneOffset() * -1 * 60 * 1000;
		return new Date((((idx * 60 * 60) + dayTime) * 1000) - zoneDiff);
	}

	ngOnDestroy() {
		this.getDailyDetails?.unsubscribe();
	}
}
